import { createContext, useContext } from 'react';

export interface PresentationStepContextValue {
  selectedTemplateIds: string[];
  setSelectedTemplateIds: (templateIds: string[]) => void;
  completeOnboarding: (templateIds: string[]) => Promise<void>;
  isCompleting: boolean;
}

export const PresentationStepContext =
  createContext<PresentationStepContextValue | null>(null);

export function usePresentationStepContext() {
  const context = useContext(PresentationStepContext);
  if (!context) {
    throw new Error(
      'usePresentationStepContext must be used within PresentationStepContext'
    );
  }
  return context;
}
